import URIS from 'constants/uris';
import http from 'services/http';

export function activateAccount(params) {
  return http.post(URIS.ACCOUNT_ACTIVATE, params);
}
